
import { useEffect, useState } from 'react';

export default function ScheduleSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('horario');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="horario" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className={`max-w-xl mx-auto transform transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="bg-white rounded-xl shadow-lg border border-blue-200 overflow-hidden">
            <div className="bg-blue-600 p-4 text-center">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-calendar-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                Horário de Atendimento
              </h3>
            </div>

            <div className="p-6 text-center">
              <div className="flex items-center justify-center mb-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-calendar-line text-blue-600 text-lg"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-bold text-gray-800">Segunda a Sexta</p>
                  <p className="text-xl font-bold text-blue-600">8h00 às 17h30</p>
                </div>
              </div>

              <div className="bg-orange-50 rounded-lg p-3">
                <div className="flex items-center justify-center">
                  <i className="ri-restaurant-line mr-2 text-orange-600"></i>
                  <p className="text-orange-700 font-medium text-sm">Intervalo: 12h às 13h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
